@if (loading) {
  <div class="fui-layout-container">
    <div class="fui-layout-pad-content">
      <myp-skeleton-loader type="line" width="36%" extraContainerClass="m-t-100 m-b-50" height="30px"></myp-skeleton-loader>
      <myp-skeleton-loader type="line" width="98%" extraContainerClass="m-b-10" height="10px"></myp-skeleton-loader>
      <myp-skeleton-loader type="line" width="100%" extraContainerClass="m-b-10" height="10px"></myp-skeleton-loader>
      <myp-skeleton-loader type="line" width="40%" extraContainerClass="m-b-50" height="10px"></myp-skeleton-loader>
    </div>
  </div>
}

@if (!loading && !event) {
  <div class="fui-layout-container">
    <div class="fui-layout-pad-content m-y-50">
      <fui-heading [text]="'events.event_not_found' | translate" fontSize="f7" level="2"></fui-heading>
      <p class="m-t-20">{{ "events.event_not_available" | translate }}</p>
    </div>
  </div>
}

@if (event) {
  <div class="fui-layout-container">
    <fui-layout-header [breadcrumbs]="breadcrumbs" [headingText]="event.title"></fui-layout-header>
    <hr />

    <div class="fui-layout-pad-content">
      <div class="d-flex justify-content-between flex-wrap">
        <div class="m-y-30 d-flex align-items-center flex-wrap">
          <div class="m-r-30 m-y-10">
            <fa-icon icon="calendar" class="m-r-5"></fa-icon>
            {{ formattedDate }}
          </div>
          <div class="m-r-30 m-y-10">
            <fa-icon icon="clock" class="m-r-5"></fa-icon>
            {{ formattedEndTime }}
          </div>
          <div class="m-r-30 m-y-10">
            <fa-icon icon="globe" class="m-r-5"></fa-icon>
            {{ userTimezone }}
          </div>
        </div>
        @if (isUpcoming) {
          <div class="d-flex justify-content-end align-items-center" style="gap: 12px">
            @if (!reminderSet) {
              <button class="btn btn-primary" (click)="remindMe()">
                <fa-icon icon="bell" class="m-r-5"></fa-icon>
                Remind Me
              </button>
            } @else {
              <button class="btn btn-secondary" [disabled]="reminderSaving" (click)="remindMe()">
                <fa-icon icon="check" class="m-r-5"></fa-icon>
                Reminder Set
              </button>
            }
            <button class="btn btn-secondary" (click)="addToCalendar()">
              <fa-icon icon="calendar" class="m-r-5"></fa-icon>
              Add to Calendar
            </button>
          </div>
        }
      </div>
    </div>
    <hr />
    <div class="fui-layout-pad-content">
      @if (requiresUpgrade) {
        <div class="m-t-50 m-b-50">
          <fui-heading [text]="'events.event_exclusive_members' | translate" fontSize="f7" level="2"></fui-heading>
          <p class="m-t-20">{{ "events.upgrade_to_access_event" | translate }}</p>
          <button class="btn btn-primary m-t-20" (click)="upgrade()">{{ "events.upgrade_to_studio_pro" | translate }}</button>
        </div>
      } @else {
        @if (eventsService.isLivestreamEvent(event)) {
          <div class="m-t-30 m-b-30">
            <fui-upcoming-live-event [event]="event" [viewingEventPage]="true"></fui-upcoming-live-event>
          </div>
        }

        @if (htmlDescription) {
          <div class="m-t-30 m-b-30 quill-content">
            <div [innerHTML]="htmlDescription | safe: 'html'"></div>
          </div>
        }

        @if (event.image_url) {
          <div class="m-t-30 m-b-30">
            <img [src]="event.image_url" style="width: 100%; border-radius: 8px; max-width: 1000px" />
          </div>
        }

        @if (!event.online && (event.address || event.city)) {
          <div class="m-b-20">
            <fa-icon icon="location-dot" class="m-r-5"></fa-icon>
            <span>{{ locationString }}</span>
          </div>
        }
      }
    </div>

    <div class="m-t-100 p-b-50">
      <fui-footer></fui-footer>
    </div>

    <ng-template #reminderModal let-modal>
      <div class="modal-header">
        <h5 class="modal-title" id="modal-title">Remind me about "{{ event.title }}"</h5>
        <button ngbAutofocus class="close" aria-label="Close" (click)="modal.close()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        @for (option of reminderOptions; track option.value) {
          <label class="d-block m-b-10" style="cursor: pointer">
            <input type="checkbox" [checked]="option.checked" (change)="toggleReminderOption(option)" class="m-r-5" />
            {{ option.label }}
          </label>
        }
        <p class="m-t-10" style="font-size: 12px; opacity: 0.7">
          You'll also be reminded when the event starts.
          @if (isRecurring) {
            This reminder applies to every date in this series.
          }
        </p>
      </div>
      <div class="modal-footer d-flex justify-content-between align-items-center">
        <span>
          @if (reminderSet) {
            <button class="btn btn-transparent" style="color: #d52b1e" [disabled]="reminderSaving" (click)="cancelReminder()">Remove reminder</button>
          }
        </span>
        <span class="d-flex" style="gap: 8px">
          <button class="btn btn-transparent" [disabled]="reminderSaving" (click)="cancelReminderEdit()">Cancel</button>
          <button class="btn btn-primary" [disabled]="reminderSaving" (click)="saveReminder()">Save</button>
        </span>
      </div>
    </ng-template>
  </div>
}
